import {
  Cancel,
  Save,
  ArrowForward as ArrowForwardIcon,
  ArrowBack as ArrowBackIcon,
} from '@mui/icons-material';
import { Typography, Divider, Stepper, Step, StepLabel } from '@mui/material';
import Grid2 from '@mui/material/Grid2';
import React, { useState, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { NewCustomer, InputClaimTypes, Param } from '../Model/CustomerModel';
import CloneTenantForm from './CloneTenantForm';
import { customerService } from '../CustomerService';
import TenantRegistrationForm from '../../Tenant/Components/TenantRegistrationForm';
import { StorageAccount } from '../../StorageAccount/Model/StorageAccountModel';
import { AzureSearchService } from '../../SearchService/Model/AzureSearchServiceModel';
import {
  CloneTenantMetaData,
  DeployDetailsForm,
  RegisterTenant,
  TenantForm,
} from '../../Tenant/Model/TenantModels';
import { storageAccountService } from '../../StorageAccount/StorageAccountService';
import { azureSearchServiceService } from '../../SearchService/AzureSearchServiceService';
import { farmService } from '../../ManageFarms/FarmService';
import {
  RemoveDuplicateAppserviceplans,
  createNewAppServicePlan,
} from '../../../../Common/CommonMethods';
import { Loader } from '../../../../Common/Components/Loader';
import { tenantService } from '../../Tenant/TenantService';
import { ValidationErrors } from 'fluentvalidation-ts';
import DeploymentForm from './DeploymentForm';
import { azureDevOpsService } from '../../AzureDevOps/AzureDevOpsService';
import { useFormStyles } from '../../../../Common/Styles';
import { sqlServerService } from '../../SqlServer/SqlServerService';
import { SqlServer } from '../../SqlServer/Model/SqlServerModel';
import {
  FooterContainer,
  FooterWrapper,
  PaperWrapper,
} from '../../Common/CommonComponents';
import { useTranslation } from 'react-i18next';
import { showToast } from '../../../../lib/toast';
import { CustomButton } from '../../../../Common/Components/Controls/InputControls';

function GetSteps() {
  return ['Create Customer', 'Register Tenant to Farm', 'Deployment Details'];
}

const CloneTenant = () => {
  const { classes } = useFormStyles();
  const { t } = useTranslation('customer');
  const params = useParams<Param>();
  const history = useHistory();
  const [loading, setLoading] = useState<number>(0);

  //create customer
  const [groupNames, setGroupNames] = useState<string[]>([]);
  const [activeStep, setActiveStep] = useState(0);
  const initalCustomer: NewCustomer = {};
  const [customer, setCustomer] = useState<NewCustomer>(initalCustomer);
  const [FarmId, setFarmId] = useState<string>();
  const [registerTenant, setRegisterTenant] = useState<RegisterTenant>();
  const [openAppserviceDialogue, setOpenAppserviceDialogue] =
    React.useState(false);
  const [storageAccount, setStorageAccount] = React.useState('');
  const [azureSearchService, setAzureSearchService] = React.useState('');
  const [sqlServers, setSqlServers] = useState<SqlServer[]>([]);
  const [replicaServers, setReplicaServers] = useState<SqlServer[]>([]);
  const [sqlServer, setSqlServer] = useState('');
  const [appserviceplans, setAppserviceplans] = React.useState<string[]>([]);
  const [replicas, setreplicas] = useState<string[]>([]);
  const [appserviceplan, setAppserviceplan] = React.useState('');
  const [selectedValue, setSelectedValue] = React.useState('Not Selected');
  const [storageAccounts, setStorageAccounts] = React.useState<
    StorageAccount[]
  >([]);
  const [azureSearchServices, setAzureSearchServices] = React.useState<
    AzureSearchService[]
  >([]);
  const [deployDetailsForm, setDeployDetailsForm] =
    React.useState<DeployDetailsForm>({
      Branch: '',
    });
  const [branches, setBranches] = React.useState<string[]>([]);

  const [customerErrors, setCustomerErrors] = useState<
    ValidationErrors<NewCustomer>
  >({});
  const [tenantErrors, setTenantErrors] = useState<
    ValidationErrors<TenantForm>
  >({});
  const [deploymentErrors, setDeploymentErrors] = useState<
    ValidationErrors<DeployDetailsForm>
  >({});

  const [enableExternalIdentity, setEnableExternalIdentity] = useState(false);

  useEffect(() => {
    const InitData = async () => {
      const loadGroupNames = async () => {
        try {
          setLoading(loading + 1);
          const groupNames = await customerService.getGroupNames();
          setGroupNames(groupNames.Items);
        } catch (error) {
          console.log(error);
        } finally {
          setLoading(loading - 1);
        }
      };

      const loadSqlServers = async () => {
        try {
          setLoading(loading + 1);
          await sqlServerService.getSqlServers().then((sqlservers) => {
            setSqlServers(sqlservers.Items);
            setReplicaServers(sqlservers.Items);
          });
        } catch (error) {
          console.log(error);
        } finally {
          setLoading(loading - 1);
        }
      };

      const loadBranches = async () => {
        try {
          setLoading(loading + 1);
          const response = await azureDevOpsService.getProarcSetupBranches();
          const branchItems = Array.isArray(response)
            ? response
            : response?.Items ?? [];
          setBranches(branchItems);
        } catch (error) {
          console.log(error);
        } finally {
          setLoading(loading - 1);
        }
      };

      const loadRegisterTenant = async () => {
        setLoading(loading + 1);
        await customerService
          .getRegisterTenant(params.customerId)
          .then((data) => {
            setRegisterTenant(data);
            setLoading(loading - 1);
          });
      };

      const loadStorageAccounts = async () => {
        try {
          await storageAccountService
            .getstorageAccounts()
            .then((storageAccounts) => {
              setStorageAccounts(
                storageAccounts.Items.filter(
                  (sa) => sa.Purpose.toLowerCase() === 'archive',
                ),
              );
            });
        } catch (error) {
          console.log(error);
        }
      };
      const loadAzureSearchServices = async () => {
        try {
          await azureSearchServiceService
            .getAzureSearchServices()
            .then((azureSearchServices) => {
              setAzureSearchServices(azureSearchServices.Items);
            });
        } catch (error) {
          console.log(error);
        }
      };
      const loadDefaultValues = async () => {
        try {
          setLoading(loading + 1);
          const sourceCustomer = await customerService.getEditCustomer(
            params.customerId,
          );
          if (sourceCustomer) {
            setCustomer({
              ...customer,
              Id: sourceCustomer.Id,
              Subdomain: sourceCustomer.Subdomain + '-clone',
              CustomerName: sourceCustomer.CustomerName + '-clone',
              EnterpriseNumber: sourceCustomer.EnterpriseNumber,
              SetupType: sourceCustomer.SetupType,
              GroupName: sourceCustomer.GroupName,
              AzureDBServiceObjective: sourceCustomer.AzureDBServiceObjective,
              IdentityProviders: sourceCustomer.IdentityProviders,
              AdminUser: sourceCustomer.AdminUser,
              AzureADAppClientID: '',
              WSFederationUrl: '',
              InputClaimType:
                InputClaimTypes[sourceCustomer.IdentityProviders ?? ''],
              EnableProArcLogin: sourceCustomer.EnableProArcLogin,
              AuthProviderName: sourceCustomer.AuthProviderName,
              ContactPersons: sourceCustomer.ContactPersons,
              AdminUserName: sourceCustomer.AdminUserName,
            });
          }
        } catch (error) {
          console.log(error);
        } finally {
          setLoading(loading - 1);
        }
      };
      await loadGroupNames().catch((err) => console.log(err));
      await loadDefaultValues().catch((err) => console.log(err));
      await loadRegisterTenant().catch((err) => console.log(err));
      await loadStorageAccounts().catch((err) => console.log(err));
      await loadAzureSearchServices().catch((err) => console.log(err));
      await loadSqlServers().catch((err) => console.log(err));
      await loadBranches().catch((err) => console.log(err));
    };
    InitData();
  }, [customer, loading, params.customerId]);

  const setEnableProarcLogin = (value: boolean) => {
    setCustomer({
      ...customer,
      EnableProArcLogin: value,
    });
  };

  const handleFieldValueChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const name = event.target.name;
    const value = event.target.value;
    setCustomer({
      ...customer,
      [name]: value,
    });

    if (name === 'IdentityProviders') {
      setCustomer({
        ...customer,
        IdentityProviders: value,
        InputClaimType: InputClaimTypes[value],
      });
    }
  };

  const handleDeploymentFormChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const { name, value } = event.target;
    setDeployDetailsForm({
      ...deployDetailsForm,
      [name]: value,
    });
  };

  const loadAppserviceplans = (farmId: number) => {
    farmService.getAppservicePlans(farmId).then((appserviceplans) => {
      setAppserviceplans(appserviceplans);
    });
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    setFarmId(value);
    const farmId = Number(value);
    loadAppserviceplans(farmId);
    setStorageAccounts(
      storageAccounts.filter(
        (sa) =>
          sa.AzureRegion ===
          registerTenant?.Farms.find((farm) => farm.Id === farmId)?.FarmRegion,
      ),
    );
    setStorageAccount('');
    setAzureSearchServices(
      azureSearchServices.filter(
        (sa) =>
          sa.AzureRegion ===
          registerTenant?.Farms.find((farm) => farm.Id === farmId)?.FarmRegion,
      ),
    );
    setAzureSearchService('');
  };

  const handleReplicaChange = (values: string[]) => {
    let duplicatesRemoved: string[] = [];

    values.forEach((item) => {
      if (duplicatesRemoved.includes(item)) {
        duplicatesRemoved = duplicatesRemoved.filter((x) => x === item);
      } else {
        duplicatesRemoved.push(item);
      }
    });

    setreplicas(duplicatesRemoved);
  };

  const addItemToState = (item: string[]) => {
    const newItem = createNewAppServicePlan(
      appserviceplans,
      item,
      Number(FarmId),
    );
    const appAppservicePlans = appserviceplans.concat(appserviceplans, newItem);
    setAppserviceplans(RemoveDuplicateAppserviceplans(appAppservicePlans));
  };

  const handleCloseAppservicePlan = (value: string) => {
    setOpenAppserviceDialogue(false);
    if ('Not Selected' !== value) {
      setSelectedValue(value);
      const appserviceplan: string[] = [];
      appserviceplan.push(value);
      addItemToState(appserviceplan);
    }
  };

  const handleClickOpen = () => {
    setOpenAppserviceDialogue(true);
  };

  const validateAuthenticationTypes = () => {
    if (!customer.EnableProArcLogin && !enableExternalIdentity) {
      showToast({
        type: 'info',
        title: t('cloneTenant.validation.selectAuthenticationType'),
      });
      return false;
    }
    return true;
  };

  const validateIdentityProviderSection = () => {
    if (
      enableExternalIdentity &&
      (customerErrors.AzureADAppClientID ||
        customerErrors.WSFederationUrl ||
        customerErrors.IdentityProviders ||
        customerErrors.InputClaimType ||
        customerErrors.AuthProviderName)
    ) {
      showToast({
        type: 'info',
        title: t('cloneTenant.validation.fillIdentityProviderSection'),
      });
      return false;
    }
    return true;
  };

  const validateCustomerSection = () => {
    if (
      customerErrors.Subdomain ||
      customerErrors.CustomerName ||
      customerErrors.ContactPersons ||
      customerErrors.GroupName ||
      customerErrors.AdminUserName ||
      customerErrors.AdminUser
    ) {
      showToast({
        type: 'info',
        title: t('cloneTenant.validation.fillIdentityProviderSection'),
      });
      return false;
    }
    return true;
  };

  const validateFarmTenantSection = () => {
    if (
      tenantErrors.FarmId ||
      tenantErrors.StorageAccount ||
      tenantErrors.AzureSearchService ||
      tenantErrors.AppservicePlan
    ) {
      showToast({
        type: 'info',
        title: t('cloneTenant.validation.fillFarmTenantSection'),
      });
      return false;
    }
    return true;
  };

  const handleClone = async () => {
    if (
      validateAuthenticationTypes() &&
      validateIdentityProviderSection() &&
      validateCustomerSection() &&
      validateFarmTenantSection()
    ) {
      const tenantmetaData: CloneTenantMetaData = {
        Customer: customer,
        FarmId: Number(FarmId),
        StorageAccount: storageAccount,
        AzureSearchService: azureSearchService,
        AppServicePlan: appserviceplan,
        SqlServer: sqlServer,
        Replicas: replicas,
        PlatformBranch: deployDetailsForm.Branch,
      };
      tenantService.cloneTenant(params.customerId, tenantmetaData);
      showToast({
        type: 'success',
        title: t('cloneTenant.success.deploymentStarted', {
          customerName: customer.CustomerName,
        }),
      });
      setLoading(loading + 1);
      handleClose();
    }
  };

  function handleClose(): void {
    history.push('/customer');
  }

  const steps = GetSteps();

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handlePrev = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  function GetStepsContent(stepIndex: number) {
    switch (stepIndex) {
      case 0:
        return (
          <CloneTenantForm
            handleFieldValueChange={handleFieldValueChange}
            groupNames={groupNames}
            customer={customer}
            errors={customerErrors}
            setErrors={setCustomerErrors}
            enableExternalIdentity={enableExternalIdentity}
            SetEnableProArcLogin={setEnableProarcLogin}
            SetEnableExternalIdentity={setEnableExternalIdentity}
          />
        );
      case 1:
        return (
          <TenantRegistrationForm
            FarmId={FarmId ?? ''}
            appserviceplan={appserviceplan}
            setAppserviceplan={setAppserviceplan}
            appserviceplans={appserviceplans}
            customerId={params.customerId}
            storageAccount={storageAccount}
            setStorageAccount={setStorageAccount}
            storageAccounts={storageAccounts}
            azureSearchService={azureSearchService}
            setAzureSearchService={setAzureSearchService}
            azureSearchServices={azureSearchServices}
            sqlServer={sqlServer}
            setSqlServer={setSqlServer}
            sqlServers={sqlServers}
            replicaServers={replicaServers}
            handleChange={handleChange}
            handleClickOpen={handleClickOpen}
            registerTenant={registerTenant}
            handleCloseAppservicePlan={handleCloseAppservicePlan}
            openAppserviceDialogue={openAppserviceDialogue}
            selectedValue={selectedValue}
            setOpenAppserviceDialogue={setOpenAppserviceDialogue}
            handleReplicaSelection={handleReplicaChange}
            replicas={replicas}
            errors={tenantErrors}
            setErrors={setTenantErrors}
          />
        );

      default:
        return (
          <DeploymentForm
            deployDetailsForm={deployDetailsForm}
            branches={branches}
            handleChange={handleDeploymentFormChange}
            errors={deploymentErrors}
            setErrors={setDeploymentErrors}
          />
        );
    }
  }
  return (
    <>
      <Loader loading={loading > 0} />
      <div>
        <PaperWrapper>
          <Stepper activeStep={activeStep} alternativeLabel sx={{ padding: 2 }}>
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
          <Typography variant="h5" className={classes.title}>
            Clone Tenant
          </Typography>
          <Divider className={classes.divider} />
          {GetStepsContent(activeStep)}
          <FooterWrapper>
            <FooterContainer>
              <Grid2 size={{ xs: 12, sm: 'auto' }}>
                {activeStep !== 0 && (
                  <CustomButton
                    onClick={handlePrev}
                    startIcon={<ArrowBackIcon />}
                    label="Prev"
                  />
                )}
              </Grid2>

              {activeStep === steps.length - 1 ? (
                <Grid2 size={{ xs: 12, sm: 'auto' }}>
                  <CustomButton
                    onClick={handleClone}
                    startIcon={<Save />}
                    label="Clone"
                  />
                </Grid2>
              ) : (
                <Grid2 size={{ xs: 12, sm: 'auto' }}>
                  <CustomButton
                    onClick={handleNext}
                    startIcon={<ArrowForwardIcon />}
                    label="Next"
                  />
                </Grid2>
              )}
              <Grid2 size={{ xs: 12, sm: 'auto' }}>
                <CustomButton
                  onClick={handleClose}
                  startIcon={<Cancel />}
                  label="Cancel"
                />
              </Grid2>
            </FooterContainer>
          </FooterWrapper>
        </PaperWrapper>
      </div>
    </>
  );
};

export default CloneTenant;
